<div class="page tracking history">
    <app-left-track [trackingMode]="false"></app-left-track>
    <div class="vert_collapser" id="vert_collapser" onclick="collapseTrack()">
        <span><i></i></span>
    </div>
    <app-right-history></app-right-history>
</div>
